import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverFuelCardQuickInfo extends Layout {
    sourceFuelCardDriverQuickInfo: DataSource;
    tableDriverFuelCards: Table;
}
